import { createLinkInterceptor } from '@mail-core/std';
import { useEffect } from 'react';
import { WorkspaceSuperAppService } from 'reactApp/services';
import { navigationRef } from 'reactApp/ui/App/components/NavigationSetter';

const useWorkspaceSuperappNavigation = () => {
    useEffect(() => {
        if (WorkspaceSuperAppService.isEnabled) {
            return createLinkInterceptor((data) => {
                if (data.url === 'about:blank') {
                    return null;
                }

                const url = new URL(data.url, window.location.origin);

                if (url.origin !== window.location.origin) {
                    WorkspaceSuperAppService.openLink(url.href);
                } else {
                    // data.url - относительный путь

                    switch (data.type) {
                        case 'click':
                        case 'keydown':
                            if (navigationRef.current) {
                                navigationRef.current(url.pathname);
                            } else {
                                window.location.href = url.href;
                            }
                            break;
                        case 'window.open':
                            WorkspaceSuperAppService.openLink(url.href);
                    }
                }

                return null;
            });
        }
    }, []);
};

export default useWorkspaceSuperappNavigation;
